module.exports = __webpack_public_path__ + "static/media/translate-icon.9b6238ff.png";